const employeeRegistrationRoutes = [

    {

        name: 'employeeHome',
        path: '',
        component: () => import('./ListEmployees.vue'),
        meta: {
            auth: true,
            title: 'Staff Lists',
            breadcrumb: 'Staff Lists',
            permission: ['view employee'],
            section: 'staff'
        }

    },

    {
        path: 'create',
        name: 'createEmployee',
        component: () => import('./CreateEmployee.vue'),
        meta: {
            auth: true,
            title: 'Create Staff',
            breadcrumb: 'Create Staff',
            permission: ['create employee'],
            section: 'staff'
        }
    },

    {
        path: ':id',
        name: 'showEmployee',
        component: () => import('./ShowEmployee.vue'),
        meta: {
            auth: true,
            title: 'Showing Staff',
            breadcrumb: 'Showing Staff',
            permission: ['view employee'],
            section: 'staff'
        }
    },

    {
        path: ':id/edit',
        name: 'editEmployee',
        component: () => import('./EditEmployee.vue'),
        meta: {
            auth: true,
            title: 'Edit Staff',
            breadcrumb: 'Edit Staff',
            permission: ['update employee'],
            section: 'staff'
        }
    },

];

export default employeeRegistrationRoutes;
